import { render } from "./App.vue?vue&type=template&id=733f39fe"
const script = {}

const cssModules = script.__cssModules = {}
import style0 from "./App.vue?vue&type=style&index=0&id=733f39fe&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script